module.exports = __webpack_public_path__ + "static/media/planta1.398368d9.jpg";